import React from "react";
import { connect } from "react-redux";

import SelectState from "components/sections/SelectState";
import SelectCourse from "components/sections/SelectCourse";
import SelectAtar from "components/sections/SelectAtar";
import FormControl from "components/sections/FormControl";
import FieldsOfStudy from "components/sections/FieldsOfStudy";
import Institutions from "components/sections/Institutions";

import "assets/stylesheets/Main.scss";

class Main extends React.Component {
  render = () => {
    const { activeState, selectedSubjects = [] } = this.props;
    return (
      <div id="course-compass-container">
        <div id="course-compass-main">
          <p className="intro-text">
            Not sure which course to apply for? Don't know where to start
            looking? In just a few short steps, Course Compass can show you the
            paths taken by people whose studies at school were just like yours.
          </p>
          <SelectState />
          {activeState && (
            <>
              <SelectCourse />
              {selectedSubjects.length >= 4 && (
                <>
                  <SelectAtar />
                  <FormControl />
                  <FieldsOfStudy />
                  <Institutions />
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (store) => {
  const { activeState, knowAtar } = store.selectStateReducer;
  const { selectedSubjects } = store.selectSubjectsReducer;
  return {
    activeState: activeState,
    knowAtar: knowAtar,
    selectedSubjects: selectedSubjects,
  };
};

export default connect(mapStateToProps)(Main);
